import DatabaseManager from '../data/DatabaseManager';

/**
 * Point of data access for Album related stuff
 */

class Album {
	constructor(id, title, cover, photos) {
		this.id = id
		this.title = title
		this.cover = cover
		this.photos = photos
	}
}

export default {

	get(albumId, callback) {
		DatabaseManager
			.getAlbum(albumId).onSnapshot(doc => {
				if(doc.exists) {
					callback(doc.data())
				} else {
					callback(Error("Document not found"))
				}
			})
	},

	createAlbum(title) {
		return DatabaseManager.createNewAlbum(title)
	},

	deleteAlbum(id) {
		return DatabaseManager.deleteAlbum(id)
	},

	getUserAlbums(callback) {
		DatabaseManager.getUserAlbums(snapshot => {
			let result = []
			snapshot.forEach(doc => {
				result.push(this.mapToAlbum(doc.id, doc.data().title, doc.data().cover, doc.data().photos))
			})
			callback(result);
		})
	},

	getUploadTask() {
		DatabaseManager.uploadTask(albumId, photoFile)
	},

	uploadPhotoToAlbum(albumId, photoFile, metadata, progressCallback, statusCallback, completeCallback, errorCallback) {
		DatabaseManager.uploadPhoto(albumId, photoFile, metadata, progressCallback, statusCallback, completeCallback, errorCallback)
	},

	mapToAlbum(docId, title, cover, photos) {
		return new Album(docId, title, cover, photos)
	},
}



// WEBPACK FOOTER //
// ./src/repositories/AlbumsRepository.js